const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
})

export const formatCurrency = (number: number) => formatter.format(number)

const noDecimalFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
})

export const noDecimals = (number: number) => noDecimalFormatter.format(number)

const twoDecimalFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

export const twoDecimals = (number: number) =>
  twoDecimalFormatter.format(number)

export const avatarFallback = (name: string): string =>
  name
    .split(' ')
    .slice(0, 3)
    .map((piece) => piece.at(0)?.toUpperCase())
    .join('')

// when we're rendering a negative number in the UI,
// it'll include the - symbol for us.
// but sometimes we need a positive number to render with + in front of it.
export const sign = (number: number) => (Math.sign(number) > 0 ? '+' : '')
